var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShowPage
        ? _c(
            "div",
            [
              _c(
                "el-header",
                {
                  ref: "header",
                  staticClass: "header",
                  staticStyle: { height: "auto", "margin-bottom": "10px" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchFormRef",
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.searchForm },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { id: "searchBox" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "company" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入公司名称" },
                                nativeOn: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleSearchBtn.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.searchForm.company,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "company", $$v)
                                  },
                                  expression: "searchForm.company",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "orderid" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入订单号" },
                                nativeOn: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleSearchBtn.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.searchForm.orderid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "orderid", $$v)
                                  },
                                  expression: "searchForm.orderid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "text", id: "closeSearchBtn" },
                              on: { click: _vm.closeSearch },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.word) + " "),
                              _c("i", {
                                class: _vm.showAll
                                  ? "el-icon-arrow-up "
                                  : "el-icon-arrow-down",
                              }),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSearchBtn()
                                },
                              },
                            },
                            [_vm._v("搜索 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-refresh" },
                              on: { click: _vm.handleResetBtn },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom-table search-table" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "customer-table",
                      attrs: {
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        data: _vm.list,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("Expand", {
                                    attrs: {
                                      list: scope.row.childdata,
                                      activeName: _vm.activeName,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2236830721
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "ID", prop: "id" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "订单号", prop: "orderid" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "报价公司", prop: "company" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "报价人员", prop: "rname" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "报价价格", prop: "zprice" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "报价时间", prop: "settime" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generateQuotation(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("生成报价单")]
                                  ),
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: { title: "确认要生成合同吗？" },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.generateContract(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "quotation-contract_btn",
                                          attrs: {
                                            slot: "reference",
                                            type: "warning",
                                            size: "small",
                                          },
                                          slot: "reference",
                                        },
                                        [_vm._v("生成合同")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1382790704
                        ),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "14px",
                      "margin-bottom": "14px",
                    },
                    attrs: {
                      "current-page": _vm.selectPage.pageNum,
                      "page-sizes": [20, 50, 100, 200],
                      "page-size": _vm.selectPage.pageSize,
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.allNum,
                    },
                    on: {
                      "size-change": _vm.pageSizeChange,
                      "current-change": _vm.pageCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("el-empty", {
            staticClass: "customer-category_empty",
            attrs: { description: "暂无权限查看数据" },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }